/*
 * Copyright 2021 gRPC authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import { ServiceDefinition } from "./make-client";
import { Server, UntypedServiceImplementation } from "./server";

interface GetServiceDefinition {
  (): ServiceDefinition;
}

interface GetHandlers {
  (): UntypedServiceImplementation;
}

const registeredAdminServices: {getServiceDefinition: GetServiceDefinition, getHandlers: GetHandlers}[] = [];

export function registerAdminService(getServiceDefinition: GetServiceDefinition, getHandlers: GetHandlers) {
  registeredAdminServices.push({getServiceDefinition, getHandlers});
}

export function addAdminServicesToServer(server: Server): void {
  for (const {getServiceDefinition, getHandlers} of registeredAdminServices) {
    server.addService(getServiceDefinition(), getHandlers());
  }
}